import { render, staticRenderFns } from "./DangerLinkButton.vue?vue&type=template&id=40c684f2"
import script from "./DangerLinkButton.vue?vue&type=script&lang=js"
export * from "./DangerLinkButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports